import { h } from 'preact'
export const IconClose = () => {
    return (
        <svg 
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
        >
            <title>close</title>
            <path d="M17.2533 15.9999L24.6222 8.63106C24.9242 8.27838 24.9039 7.75266 24.5756 7.42434C24.2472 7.09601 23.7215 7.0757 23.3688 7.37773L15.9999 14.7466L8.63106 7.36884C8.28251 7.02028 7.71739 7.02028 7.36884 7.36884C7.02029 7.71739 7.02029 8.28251 7.36884 8.63106L14.7466 15.9999L7.36884 23.3688C7.11517 23.5861 7.00468 23.9272 7.08279 24.2519C7.16089 24.5766 7.41442 24.8301 7.73913 24.9082C8.06384 24.9863 8.40494 24.8758 8.62217 24.6222L15.9999 17.2533L23.3688 24.6222C23.7215 24.9242 24.2472 24.9039 24.5756 24.5756C24.9039 24.2472 24.9242 23.7215 24.6222 23.3688L17.2533 15.9999Z" fill="currentColor"/>
        </svg>
    )
}
